import { createEffect, createEvent, createStore } from 'effector';
import { pending } from 'patronum';
import {
  GetTicketWorksPayload,
  GetTicketWorksResponse,
  Works,
  SetTicketWorkPayload,
} from '../../interfaces';

export const $works = createStore<Works[]>([]);
export const $modeWorks = createStore<string>('view');

export const changeWorksMode = createEvent<string>();
export const setTicketWorks = createEvent<{ works: Works[] }>();
export const pushEmptytWorks = createEvent();

export const fxGetTicketWorks = createEffect<
  GetTicketWorksPayload,
  GetTicketWorksResponse,
  Error
>();
export const fxSetTicketWorks = createEffect<SetTicketWorkPayload, object, Error>();

export const $worksPending = pending({
  effects: [fxGetTicketWorks, fxSetTicketWorks],
});
